import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, switchMap, withLatestFrom } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { loadLanguageData, loadLanguageDataSuccess, loadLanguageDataFailure } from '../actions';
import { selectLanguageData } from '../selectors';
import { select, Store } from '@ngrx/store';
import { decompress } from 'compress-json';
import { environment } from 'src/environments/environment';
import localLanguageData from 'src/assets/languageStrings.js'

// @Injectable()
// export class LanguageEffects {
//   loadLanguageData$;
//   constructor(private actions$: Actions, private http: HttpClient, private store: Store) {
//     this.loadLanguageData$ = createEffect(() =>
//       this.actions$.pipe(
//         ofType(loadLanguageData),
//         withLatestFrom(this.store.pipe(select(selectLanguageData))),
//         switchMap(([action, currentData]) => {
//           if (currentData != undefined && currentData.length > 0) {
//             console.log('Data already in store, no need to call API');
//             console.log('return old fetch',new Date().toISOString())
//             return;
//             // return [loadLanguageDataSuccess({ languageData: currentData })]; // Return the existing data
//           }

//           const apiUrl = `https://languageengineapi.aitestpro.com/string/project-strings`;
//           const headers = {
//             // 'Authorization': `Bearer ${sessionStorage.getItem('accessToken')}`,
//             'Content-Type': 'application/json'
//           };
//           return this.http.post<any>(apiUrl, {project_id: 5}, { headers } ).pipe(
//             map((data) => {
//               console.log('Fetched new data:', data.strings);
//               console.log('new fetch',new Date().toISOString())
//               loadLanguageDataSuccess({ languageData: data.strings})
//             }),
//             catchError((error) => {
//               console.error('API Error:', error);
//               const errorMessage = error?.message || 'An unknown error occurred';
//               return [loadLanguageDataFailure({ error: errorMessage })]; // Dispatch failure on error
//             })
//           );
//         })
//       )
//     );
//   }
// }

@Injectable()
export class LanguageEffects {
  loadLanguageData$;
  constructor(private actions$: Actions, private http: HttpClient, private store: Store) {
    this.loadLanguageData$ = createEffect(() =>
      this.actions$.pipe(
        ofType(loadLanguageData),
        withLatestFrom(this.store.pipe(select(selectLanguageData))),
        switchMap(([action, currentData]) => {
          if (currentData != undefined && currentData.length > 0) {
            console.log('Data already in store, no need to call API');
            console.log('return old fetch', new Date().toISOString());
            return; // Returning an empty array prevents dispatching invalid actions
          }

          const apiUrl = `${environment.langApi}/string/project-strings`;
          const headers = {
            'Content-Type': 'application/json'
          };

          return this.http.post<any>(apiUrl, { project_id: 5 }, { headers }).pipe(
            map((data) => {
              console.log('Fetched new data:', data);
              console.log('new fetch', new Date().toISOString());
              return loadLanguageDataSuccess({ languageData: data.strings }); // Correctly return the success action
            }),
            catchError((error) => {
              console.error('API Error:', error);
              const errorMessage = error?.message || 'An unknown error occurred';
              return [loadLanguageDataSuccess({ languageData: localLanguageData })]; // Correctly return the local data
              // return [loadLanguageDataFailure({ error: errorMessage })]; // Dispatch failure on error
            })
          );
        })
      )
    );
  }
}

